import { useState } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { DonorService } from "../../Services/Donor.Service";

function BiologicalSex({ userData, selectedGender, setSelectedGender, setToastMessage, setToastVariant, setShowToast, setLoading }) {
  const [error, setError] = useState(null);

  const updateGender = async () => {
    setError(null);

    if (!selectedGender) {
      setError("Please select a gender before saving.");
      return;
    }
    setLoading(true);
    const payload = {
      user_id: userData.id,
      gender: selectedGender,
    };

    try {
      const response = await DonorService.updateGender(payload);
      console.log(response.message);
      setToastMessage(response.message);
      setToastVariant("success");
      setShowToast(true);
      setLoading(false);

    } catch (err) {
      console.error("Error updating gender:", err);
      setLoading(false);
      setToastMessage(err.message);
      setToastVariant("error");
      setShowToast(true);
    }
  };

  return (
    <div className="el-bg-table el-super-admin mt-3">
      <Accordion alwaysOpen defaultActiveKey={["0"]} flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header className="cursor-pointer">
          <b>BIOLOGICAL SEX (assigned at birth)</b>
        </Accordion.Header>
        <Accordion.Body>
          <container className="el-property-details-card-content">
            <Row>
              <Col md={12} className="mx-fit-content">
                <div className="d-flex justify-content-start mt-3    ">
                  {[{ id: "XY", label: "Male" }, { id: "XX", label: "Female" }].map(
                    (gender) => (
                      <div className="form-check me-3" key={gender.id}>
                        <input
                          type="radio"
                          name="gender"
                          value={gender.id}
                          checked={selectedGender === gender.id}
                          onChange={(e) => {
                            setSelectedGender(e.target.value);
                            setError(null);
                          }}
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          &nbsp; {gender.label} ({gender.id})
                        </label>
                      </div>
                    )
                  )}
                </div>

                {error && <div className="text-danger">{error}</div>}
              </Col>
            </Row>
          </container>
        </Accordion.Body>
      </Accordion.Item>
</Accordion>
      <div className="d-flex align-items-center mt-3">
        <button onClick={updateGender} className="el-main-button me-3">
          <span>Save Changes</span>
        </button>
      </div>
    </div>
  );
}

export default BiologicalSex;
